import { render, staticRenderFns } from "./MenuOverviewPopper.vue?vue&type=template&id=2f1dfb36&"
import script from "./MenuOverviewPopper.vue?vue&type=script&lang=js&"
export * from "./MenuOverviewPopper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports